<template>
  <div class="content">
    <c회원선택2 ref="selectCust" @select="selectCust" :memblist=selectCustList  />
    <s-location report title="수임사건 사임/취하 건수 조회"/>
    <!-- <h4 class="sub_title02">수임사건 사임/취하 건수 조회</h4> -->

    	<div class="btn_group mt0">
        <div class="right">
          <span v-if="reportYn == 'N'">
            <button @click="initData" class="btn icon reload">초기화</button>
            <button @click="doSearch" class="btn icon search_black">검색</button>
            <!-- <button @click="doReport" class="btn icon print">미리보기</button> -->
          </span>
          <button v-else @click="reportYn='N'" class="btn icon reload">돌아가기</button>
        </div>
    	</div>

    <div v-if="reportYn == 'N'">

      <table class="tbl01 sch_tbl">
        <tr>
          <th>사임/취하 일자</th>
          <td>
            <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_canceldtfr" :placeholder="search.iv_canceldtfr"/>
          ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.iv_canceldtto" :placeholder="search.iv_canceldtto"/>
            <br class="mobile"/>
            <s-date-range :fr.sync="search.iv_canceldtfr" :to.sync="search.iv_canceldtto" />
          </td>
        </tr>
        <tr>
          <th>조회범위</th>
          <td>
            <label><input type="radio" v-model="search.iv_extfree_yn" value="N" />전체</label> &nbsp;
            <label><input type="radio" v-model="search.iv_extfree_yn" value="Y" />면제 제외</label>
          </td>
        </tr>
        <tr v-if="$store.state.session.user.type == 'master'">
          <th>조회대상</th>
          <td>
            <label><input type="radio" v-model="search.iv_gubun" value="all"   />전체</label> &nbsp;
            <label><input type="radio" v-model="search.iv_gubun" value="select"/>담당변호사 선택</label>
          </td>
        </tr>
        <tr v-if="$store.state.session.user.type == 'master' && search.iv_gubun == 'select'">
          <th>검색할 변호사 목록</th>
          <td>
            <input type="text" v-model="search_membnm" @keydown.enter="$refs.selectCust.open('P',search_membnm,'','' )" class="w30p"/>
            <i-btn @click="$refs.selectCust.open('P',search_membnm,'','')" class="btn xs black01 ">회원선택</i-btn>

            <div class="damdang_wrap">
              <!-- div 팝업 :: 담당 변호사 검색 결과-->
              <table class="tbl01 list01">
                <tr>
                  <th width="60">등록번호</th>
                  <th>회원명</th>
                  <th>구분</th>
                </tr>
                <tr v-for="(item, i) in selectCustList" :key="i">
                  <td>{{ item.membno }}</td>
                  <td>{{ item.membnm }}</td>
                  <td><span class="btn xs org01 outline"  @click="delCust(item)">삭제</span></td>
                </tr>
              </table>
            </div><!--//damdang_wrap-->
          </td>
        </tr>
      </table>

    <h4 class="sub_title02">수임사건 사임/취하 건수</h4>
    <div class="scroll_wrap"> <!--모바일 스크롤 -->
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
      <table class="tbl01">
        <tr>
          <th rowspan="3">증표<br/> 명의자</th>
          <th colspan="16">본안사건</th>
          <th rowspan="2" colspan="2">신청</th>
          <th rowspan="2" colspan="2">등기</th>
          <th v-if="search.iv_extfree_yn == 'N'"
              rowspan="2" colspan="2">면제</th> <!-- 구분 : 전체일 경우만 보임 -->
          <th rowspan="2" colspan="2">합계</th>
        </tr>
        <tr>
          <th colspan="2">민사<br/>(일반)</th>
          <th colspan="2">민사<br/>(소액)</th>
          <th colspan="2">민사<br/>(고액)</th>
          <th colspan="2">형사</th>
          <th colspan="2">가사</th>
          <th colspan="2">행정</th>
          <th colspan="2">특허</th>
          <th colspan="2">헌법</th>
        </tr>
        <tr>
          <th>사임</th> <th>취하</th>
          <th>사임</th> <th>취하</th>
          <th>사임</th> <th>취하</th>
          <th>사임</th> <th>취하</th>
          <th>사임</th> <th>취하</th>
          <th>사임</th> <th>취하</th>
          <th>사임</th> <th>취하</th>
          <th>사임</th> <th>취하</th>
          <th>사임</th> <th>취하</th>
          <th>사임</th> <th>취하</th>
          <!-- 구분 : 전체일 경우만 보임 -->
          <template v-if="search.iv_extfree_yn == 'N'">
            <th>사임</th> <th>취하</th>
          </template>
            <th>사임</th> <th>취하</th>
        </tr>
        <template v-for="(item,idx) in list.items">
        <tr :key="'tr1_'+idx">
          <td>{{ item.membnm }}</td>
          <td>{{ item.minsa_3cnt_dang | comma }}</td>
          <td>{{ item.minsa_4cnt_dang | comma }}</td>
          <td>{{ item.minsa_5cnt_dang | comma }}</td>
          <td>{{ item.minsa_6cnt_dang | comma }}</td>
          <td>{{ item.minsa_7cnt_dang | comma }}</td>
          <td>{{ item.minsa_8cnt_dang | comma }}</td>
          <td>{{ item.hunsa_3cnt_dang | comma }}</td>
          <td>{{ item.hunsa_4cnt_dang | comma }}</td>
          <td>{{ item.gaasa_3cnt_dang | comma }}</td>
          <td>{{ item.gaasa_4cnt_dang | comma }}</td>
          <td>{{ item.hanjn_3cnt_dang | comma }}</td>
          <td>{{ item.hanjn_4cnt_dang | comma }}</td>
          <td>{{ item.tukhu_3cnt_dang | comma }}</td>
          <td>{{ item.tukhu_4cnt_dang | comma }}</td>
          <td>{{ item.hunbh_3cnt_dang | comma }}</td>
          <td>{{ item.hunbh_4cnt_dang | comma }}</td>
          <td>{{ item.sinch_3cnt_dang | comma }}</td>
          <td>{{ item.sinch_4cnt_dang | comma }}</td>
          <td>{{ item.dungi_3cnt_dang | comma }}</td>
          <td>{{ item.dungi_4cnt_dang | comma }}</td>
          <!-- 구분 : 전체일 경우만 보임 -->
          <template v-if="search.iv_extfree_yn == 'N'">
          <td>{{ item.myunj_3cnt_dang | comma }}</td>
          <td>{{ item.myunj_4cnt_dang | comma }}</td>
          </template>
          <td>{{ item.total_3cnt_dang | comma }}</td>
          <td>{{ item.total_4cnt_dang | comma }}</td>
        </tr>
        </template>
        <tr>
          <th>합계</th>
          <th>{{ total_cancel.total1_cnt  | comma }}</th>
          <th>{{ total_cancel.total2_cnt  | comma }}</th>
          <th>{{ total_cancel.total3_cnt  | comma }}</th>
          <th>{{ total_cancel.total4_cnt  | comma }}</th>
          <th>{{ total_cancel.total5_cnt  | comma }}</th>
          <th>{{ total_cancel.total6_cnt  | comma }}</th>
          <th>{{ total_cancel.total7_cnt  | comma }}</th>
          <th>{{ total_cancel.total8_cnt  | comma }}</th>
          <th>{{ total_cancel.total9_cnt  | comma }}</th>
          <th>{{ total_cancel.total10_cnt | comma }}</th>
          <th>{{ total_cancel.total11_cnt | comma }}</th>
          <th>{{ total_cancel.total12_cnt | comma }}</th>
          <th>{{ total_cancel.total13_cnt | comma }}</th>
          <th>{{ total_cancel.total14_cnt | comma }}</th>
          <th>{{ total_cancel.total15_cnt | comma }}</th>
          <th>{{ total_cancel.total16_cnt | comma }}</th>
          <th>{{ total_cancel.total17_cnt | comma }}</th>
          <th>{{ total_cancel.total18_cnt | comma }}</th>
          <th>{{ total_cancel.total19_cnt | comma }}</th>
          <th>{{ total_cancel.total20_cnt | comma }}</th>
          <!-- 구분 : 전체일 경우만 보임 -->
          <template v-if="search.iv_extfree_yn == 'N'">
          <th>{{ total_cancel.total21_cnt | comma }}</th>
          <th>{{ total_cancel.total22_cnt | comma }}</th>
          </template>
          <th>{{ total_cancel.total23_cnt | comma }}</th>
          <th>{{ total_cancel.total24_cnt | comma }}</th>
        </tr>
      </table>
      <div class="mt15 red01" style="line-height: 20px;">
      <template v-if="$store.state.session.user.type == 'master'">
        * 마스터계정으로 조회시 사임 건수는 전체사임 건으로 조회됩니다.<br/>
      </template>
      </div>
    </div> <!--// scroll_wrap -->

    </div>
    <!-- // v-if = "reportYn== 'N'"-->
    <s-report :src="report" v-else/>
  </div>
</template>


<script>
let ui
export default {
  components: {
    "c회원선택2" : require('@/components/c회원선택2.vue').default,
  },
  data() {
    return {
      report : '',
      reportYn : 'N', // Y = report, N = 표
      search : {},
      search_init : {
       iv_canceldtfr : this.$moment().add(-1, 'month').format("YYYY-01-01"),
       iv_canceldtto : this.$moment().format("YYYY-MM-DD"),
       iv_gubun   : 'all',
       iv_extfree_yn : 'Y', // 면제제외 여부 : N(전체), Y(면제제외)
       iv_membnos : '-', // 마스터일때 변호사목록 ( 전체는 '-' )
      },
      selectCustList : [], // 조회할 변호사목록
      search_membnm : '', // 검색할 변호사 이름

      list: {},
      list_init: {
        loading : false,
        items: []
      },
      total : {},
      total_cancel : {},
    }
  },
  watch : {
    '$route': 'initData',
  },
  created() {
    ui = this.$ui
    this.search = { ...this.search_init }
    this.list = { ...this.list_init }
  },
  methods: {
    initData(){ // 현재 메뉴 다시 클릭 시
      this.reportYn = 'N'
      this.search = T.deepCopy(this.search_init)
      this.list = T.deepCopy(this.list_init)
      this.total = {}
      this.total_cancel = {}
    },

    selectCust(item) { // 담당변호사 검색추가 콜백
      if (this.selectCustList.filter(e => e.membclsf == item.membclsf && e.membno == item.membno).length > 0) {
        return ui.notify(`${ item.membnm }(${ item.membno })님은 이미 있습니다.`, {group: "top_left", type: "warn", title: "실패"})
      }

      item.membseq = this.selectCustList.length + 1
      this.selectCustList.push(item)
      ui.notify(`${ item.membnm }(${ item.membno })님을 추가했습니다.`, {group: "top_left", type: "success", title: "성공"})
      this.doSearch()
    },
    delCust(item) { // 담당변호사 검색추가한것 삭제
      this.selectCustList = this.selectCustList.filter(e => e.membno != item.membno)
      this.doSearch()
    },

    searchParam() { // 검색 파라미터
      return {
          ...this.search,
          iv_membnos : this.search.iv_gubun == "all" ? '-' : this.selectCustList.reduce((tot, item) => tot + '#' + _.trim(item.membno), '').replace(/^#/, ""),
      }
    },

    doSearch(){
      ui.httpGetList(this.list, '/proc/N_REPORT_VIA_CANCEL_CNT', this.searchParam(),
        ret => {
          this.list.items      = _.get(ret, "data.rs1", [])

          // 사임/취하건수 총 합계 구하기
          this.getTotal();
        })

    },
    getTotal() {

       // 사임/취하건수 합계 구하기
       this.total_cancel.total1_cnt  = this.list.items.reduce((prev, item) => prev + (T.toInt(item.minsa_3cnt_dang) + T.toInt(item.minsa_3cnt_pre)), 0)
       this.total_cancel.total2_cnt  = this.list.items.reduce((prev, item) => prev + (T.toInt(item.minsa_4cnt_dang) + T.toInt(item.minsa_4cnt_pre)), 0)
       this.total_cancel.total3_cnt  = this.list.items.reduce((prev, item) => prev + (T.toInt(item.minsa_5cnt_dang) + T.toInt(item.minsa_5cnt_pre)), 0)
       this.total_cancel.total4_cnt  = this.list.items.reduce((prev, item) => prev + (T.toInt(item.minsa_6cnt_dang) + T.toInt(item.minsa_6cnt_pre)), 0)
       this.total_cancel.total5_cnt  = this.list.items.reduce((prev, item) => prev + (T.toInt(item.minsa_7cnt_dang) + T.toInt(item.minsa_7cnt_pre)), 0)
       this.total_cancel.total6_cnt  = this.list.items.reduce((prev, item) => prev + (T.toInt(item.minsa_8cnt_dang) + T.toInt(item.minsa_8cnt_pre)), 0)
       this.total_cancel.total7_cnt  = this.list.items.reduce((prev, item) => prev + (T.toInt(item.hunsa_3cnt_dang) + T.toInt(item.hunsa_3cnt_pre)), 0)
       this.total_cancel.total8_cnt  = this.list.items.reduce((prev, item) => prev + (T.toInt(item.hunsa_4cnt_dang) + T.toInt(item.hunsa_4cnt_pre)), 0)
       this.total_cancel.total9_cnt  = this.list.items.reduce((prev, item) => prev + (T.toInt(item.gaasa_3cnt_dang) + T.toInt(item.gaasa_3cnt_pre)), 0)
       this.total_cancel.total10_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.gaasa_4cnt_dang) + T.toInt(item.gaasa_4cnt_pre)), 0)
       this.total_cancel.total11_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.hanjn_3cnt_dang) + T.toInt(item.hanjn_3cnt_pre)), 0)
       this.total_cancel.total12_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.hanjn_4cnt_dang) + T.toInt(item.hanjn_4cnt_pre)), 0)
       this.total_cancel.total13_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.tukhu_3cnt_dang) + T.toInt(item.tukhu_3cnt_pre)), 0)
       this.total_cancel.total14_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.tukhu_4cnt_dang) + T.toInt(item.tukhu_4cnt_pre)), 0)
       this.total_cancel.total15_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.hunbh_3cnt_dang) + T.toInt(item.hunbh_3cnt_pre)), 0)
       this.total_cancel.total16_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.hunbh_4cnt_dang) + T.toInt(item.hunbh_4cnt_pre)), 0)
       this.total_cancel.total17_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.sinch_3cnt_dang) + T.toInt(item.sinch_3cnt_pre)), 0)
       this.total_cancel.total18_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.sinch_4cnt_dang) + T.toInt(item.sinch_4cnt_pre)), 0)
       this.total_cancel.total19_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.dungi_3cnt_dang) + T.toInt(item.dungi_3cnt_pre)), 0)
       this.total_cancel.total20_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.dungi_4cnt_dang) + T.toInt(item.dungi_4cnt_pre)), 0)
       this.total_cancel.total21_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.myunj_3cnt_dang) + T.toInt(item.myunj_3cnt_pre)), 0)
       this.total_cancel.total22_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.myunj_4cnt_dang) + T.toInt(item.myunj_4cnt_pre)), 0)
       this.total_cancel.total23_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.total_3cnt_dang) + T.toInt(item.total_3cnt_pre)), 0)
       this.total_cancel.total24_cnt = this.list.items.reduce((prev, item) => prev + (T.toInt(item.total_4cnt_dang) + T.toInt(item.total_4cnt_pre)), 0)
    },
    doReport(){
      this.reportYn = 'Y'
      let url = "/ClipReport4/via_suim_cnt.jsp"

    /*  리포트
        iv_extfree_yn = N = 전체      : via_suim_cnt_all.crf
        iv_extfree_yn = Y = 면제 제외 : via_suim_cnt_extfree.crf
    */

      let params = {

         iv_membclsf : this.$store.state.session.user.membclsf,
         iv_membno   : this.$store.state.session.user.membno,
         iv_membnm   : this.$store.state.session.user.name,
         iv_membtype : this.$store.state.session.user.type,
         iv_membnos  : this.search.iv_gubun == "all" ? '-' : this.selectCustList.reduce((tot, item) => tot + '#' + item.membno, '').replace(/^#/, ""),

        iv_searchdtgbn : this.search.iv_searchdtgbn,
        iv_viadtfr     : this.search.iv_canceldtfr,
        iv_viadtto     : this.search.iv_canceldtto,
        iv_extfree_yn  : this.search.iv_extfree_yn,

         login_pers     : this.$store.state.session.user.membno
      }

      // params 객체를 urlQueryString 형식으로 변환
      let paramString = T.makeUrlQueryString(params)

      // report : url + 파라미터로 정의
      this.report = `${url}?${paramString}&r=` + Math.random()
    },

  },

}
</script>
